import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import { ProfileCard } from "../../../components/ui-library/ProfileCard/ProfileCard";
import SmartFavoritesTable from "../../../components/smart/LCF401/FavoritesTable/FavoritesTable";
import SmartPageHeader from "../../../components/smart/PageHeader/PageHeader";
import { mapStateToPropsLogin } from "../../../modules/login";
import { useTranslation } from "react-i18next";

const ProfileCardsWrapper = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  @media (max-width: 1024px) {
    margin-left: 0px;
    margin-right: 0px;
  }
`;

const Favorites = (props) => {
  const {
    route: { study },
    canViewFavorites,
  } = props;

  const { t } = useTranslation();

  return (
    <>
      <SmartPageHeader
        title={t("appText.favorites")}
        shouldFetchParticipant={true}
        studyId={study}
      />

      {canViewFavorites && (
        <ProfileCardsWrapper>
          <ProfileCard title={t("appText.favorites")} showIcon={false}>
            <SmartFavoritesTable studyId={study} />
          </ProfileCard>
        </ProfileCardsWrapper>
      )}
    </>
  );
};

export default withTheme(
  connect((state) => {
    return {
      ...mapStateToPropsLogin(state),
      loginReducer: state?.loginReducer,
    };
  })(Favorites)
);
